import { Injectable } from '@angular/core';
import * as _ from 'underscore';

@Injectable({ providedIn: 'root'})
export class FormDataReader {

    constructor() {

    }

    readFileAsBase64(template: FormData): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            var reader = new FileReader();
            if (template) {
                var file = <File>template.get('file[]');
                var fileResult = null;
                reader.readAsDataURL(file);
                reader.addEventListener('load', function () {
                    fileResult = reader.result;
                }, false);

                reader.onloadend = () => {
                    if (fileResult) {
                        var fileBase64 = fileResult.split('base64,')[1];
                        resolve(fileBase64);
                    }
                    reject('Unable to read file');
                };
            } else {
                resolve('');
            }
        });
    }
}